import {
  deleteAdminV1OrgAttributesId,
  deleteAdminV1OrgAttributesIdValuesValueId,
  patchAdminV1OrgAttributesId,
  patchAdminV1OrgAttributesIdValuesReorder,
  patchAdminV1OrgAttributesIdValuesValueId,
  type Attribute,
  type AttributeValueUpdated,
  type UpdateAttributeRequest,
  type UpdateAttributeValueRequest,
} from '@nucleus-commerce/api-client/admin';

/** Edits to the attribute dictionary; listing and creating stay in `dictionary-api.ts`. */
export const attributesApi = {
  update: (id: string, body: UpdateAttributeRequest): Promise<Attribute> =>
    patchAdminV1OrgAttributesId({ id }, body),
  remove: (id: string): Promise<void> => deleteAdminV1OrgAttributesId({ id }),
  /** Every value id of the attribute, in the new order; answers the attribute. */
  reorderValues: (attributeId: string, valueIds: string[]): Promise<Attribute> =>
    patchAdminV1OrgAttributesIdValuesReorder({ id: attributeId }, { valueIds }),
  updateValue: (
    attributeId: string,
    valueId: string,
    body: UpdateAttributeValueRequest,
  ): Promise<AttributeValueUpdated> =>
    patchAdminV1OrgAttributesIdValuesValueId({ id: attributeId, valueId }, body),
  removeValue: (attributeId: string, valueId: string): Promise<void> =>
    deleteAdminV1OrgAttributesIdValuesValueId({ id: attributeId, valueId }),
};
